import { render, staticRenderFns } from "./CruiseSearchInput.vue?vue&type=template&id=704a67f1&scoped=true"
import script from "./CruiseSearchInput.vue?vue&type=script&lang=js"
export * from "./CruiseSearchInput.vue?vue&type=script&lang=js"
import style0 from "./CruiseSearchInput.vue?vue&type=style&index=0&id=704a67f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a67f1",
  null
  
)

export default component.exports